module.exports = __webpack_public_path__ + "media/application/images/ui/icon-yes-tick-8f3c3a5c11ecc2eaf2326be6116c95ab.png";